import React from 'react';

import DescriptionProduct from 'components/Shared/DescriptionProduct';

import { IListProductProps } from 'interfaces/listProduct';
import List from '../../List';

export function ListProduct({ product, onSelected }: IListProductProps) {
  return (
    <List.Option value={product} onSelected={onSelected}>
      <DescriptionProduct image={product?.image} productId={product?.id} title={product?.name} />
    </List.Option>
  );
}
